import LocalityLinkCard from './locality-link-card';
export default LocalityLinkCard;